import cs from 'classnames';

import { formatLargeNumber } from 'lib/helpers/utility';
import { LIMIT_OPTIONS } from 'lib/constants/constants';

import Button from 'components/shared/Button/Button';
import Popover from 'components/shared/Popovers/Popover/Popover';
import Typography from 'components/shared/Typography/Typography';
import CustomPagination from 'components/shared/CustomPagination/CustomPagination';

const TablePagination = ({ page, limit, totalItems, setLimit, setPage, onPageChange }) => {
  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, totalItems);

  return (
    <div className="flex items-center justify-between border-0 border-t border-solid border-[#E9EAEB] bg-white px-4 py-2">
      <div className="flex items-center gap-1">
        <Typography variant="label" size="small" weight="medium" color="neutral-700">
          {formatLargeNumber(start)}
        </Typography>
        <Typography variant="label" size="small" color="neutral-500">
          to
        </Typography>
        <Typography variant="label" size="small" weight="medium" color="neutral-700">
          {formatLargeNumber(end)}
        </Typography>
        <Typography variant="label" size="small" color="neutral-500">
          of
        </Typography>
        <Typography variant="label" size="small" weight="medium" color="neutral-700">
          {formatLargeNumber(totalItems)}
        </Typography>
        <Typography variant="label" size="small" color="neutral-500" className="ml-2">
          Show
        </Typography>
        <Popover
          customButtonTrigger={({ open }) => (
            <Button
              variant="tertiary"
              size="small"
              text={String(limit)}
              iconRight="chevron-down-linear"
              iconShade={700}
              color="neutral"
              iconSize={16}
              className={cs('h-6 w-fit bg-white py-0 pl-2 pr-1', open && 'bg-neutral-100')}
            />
          )}
          optionIconColor="neutral"
          iconsShade={700}
          options={LIMIT_OPTIONS}
          onOptionClick={(option, handleClose) => {
            setLimit(option.value);
            setPage(1);
            handleClose();
          }}
          textClassName="text-neutral-900"
          isFixed
          position="left"
        />
      </div>
      <CustomPagination
        page={page}
        perPage={limit}
        totalItems={totalItems}
        onPageChange={onPageChange}
        pageCountOverride={null}
      />
    </div>
  );
};

export default TablePagination;
